
export type UserId = string;

export enum MemberTypeEnum {
  trainer = 'trainer',
  client = 'client',
}


export interface PermissionsModel {
  [key: UserId]: MemberTypeEnum;
}
  